import ShowSocialMediaUpdateInputs from './ShowSocialMediaUpdateInputs';

export default ShowSocialMediaUpdateInputs;
